import * as React from 'react';

function SvgBellOff(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M1.613.21l.094.083 22 22a1 1 0 01-1.32 1.497l-.094-.083-5.319-5.318L3 18.39c-1.194 0-1.688-1.495-.794-2.216l.1-.074c.213-.142.635-.587 1.097-1.434C4.237 13.136 4.75 11 4.75 8.143a7.11 7.11 0 01.217-1.76L.293 1.707A1 1 0 011.613.21zm12.619 19.925a1 1 0 01.363 1.367 3 3 0 01-5.19 0 1 1 0 011.666-1.101l.129.196a1 1 0 001.6 0l.065-.099a1 1 0 011.367-.363zm.242-4.246L7.244 8.66c-.058 2.866-.603 5.157-1.5 6.927l-.162.302h8.892zm.95-14.288A7.25 7.25 0 0119.25 8v.019a16.64 16.64 0 00.586 4.65 1.25 1.25 0 11-2.412.66 19.14 19.14 0 01-.674-5.35v.018A4.75 4.75 0 009.364 4.04a1.25 1.25 0 01-1.388-2.08 7.25 7.25 0 017.449-.36z" />
    </svg>
  );
}

export default SvgBellOff;
